<template>
  <div class="wrapper">
    <div class="card small-card solo-card">
      <!-- basic login form -->
      <form @submit.prevent="signIn">
        <h2>Log In</h2>
        <div class="input-group">
          <label for="email">Email</label>
          <input class="input" type="email" id="email" v-model="form.email" required />
        </div>
        <div class="input-group">
          <label for="password">Password</label>
          <input class="input" type="password" id="password" v-model="form.password" required />
        </div>
        <div class="button-list">
          <router-link to="/resetPassword">Forgot Password</router-link>
          <router-link to="/register" class="button-secondary">Sign Up Instead</router-link>
          <button type="submit" class="button button-primary">Log In</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    // wrap data gotten from form input in vue's reactive object
    const form = reactive({
      email: "",
      password: "",
    });
    //create new store instance
    const store = useStore();
    const signIn = () => {
      // dispatch the sign in action to Log in the user
      store.dispatch("signInAction", form);
    };
    return {
      form,
      signIn,
    };
  },
};
</script>